<template>
  <div class="view">
    <UserSearch
      class="user-search"
      @selected="openChat($event.chat)"
      @create="onCreate"
      :addButton="$isGod()"
    />

    <div class="mx-auto p-5 users">
      <div class="flex space-x-2 text-base pb-4 justify-center">
        <div
          class="cursor-pointer"
          :class="{'opacity-50': tab !== 'all'}"
          @click="tab = 'all'"
        >
          Все пользователи
        </div>
        <div class="opacity-50">|</div>
        <div
          class="cursor-pointer"
          :class="{'opacity-50': tab !== 'subs'}"
          @click="tab = 'subs'"
        >
          С подпиской
        </div>
      </div>

      <div class="text-sm opacity-30 grid justify-center" :class="{
        'grid-cols-[130px,200px,200px]': tab === 'all',
        'grid-cols-[130px,200px,1fr,1fr,1fr,75px,1fr,1fr,1fr,1fr]': tab === 'subs',
      }">
        <div>Телефон</div>
        <div>Имя</div>
        <div>Дата регистрации</div>

        <template v-if="tab === 'subs'">
          <div class="">Начало подписки</div>
          <div class="">Дата отмены</div>
          <div class="">Триал</div>
          <div class="">Конец триала</div>
          <div class="">Промокод</div>
          <div class="">Цена подписки</div>
          <div class="">Оффер подписки</div>
        </template>
      </div>

      <div
        v-for="user in users"
        :key="user.id"
        @click="openChat(user.supportChat)"
        class="cursor-pointer text-sm grid py-2 justify-center hover:text-indigo-500"
        :class="{
          'grid-cols-[130px,200px,200px]': tab === 'all',
          'grid-cols-[130px,200px,1fr,1fr,1fr,75px,1fr,1fr,1fr,1fr]': tab === 'subs',
        }"
      >
        <div>
          {{ user.phone }}
        </div>
        <div>
          {{ getFullname(user) }}
        </div>
        <div>
          {{ format(user.createdAt) }}
        </div>

        <template v-if="tab === 'subs'">
          <div>{{ format(user.activeSub?.createdAt) }}</div>
          <div>{{ format(user.activeSub?.endedAt) || '–' }}</div>
          <div>{{ user.activeSub?.trial ? 'Да' : 'Нет' }}</div>
          <div>
            <template v-if="user.activeSub?.trialPeriod">
              <span >
                {{ format(addDays(new Date(user.activeSub?.createdAt), user.activeSub.trialPeriod))}}
              </span><br />
              <span class="opacity-50">({{ user.activeSub.trialPeriod }} дней)</span>
            </template>
            <span v-else>–</span>
          </div>
          <div>{{ user.activeSub?.promocode || '–' }}</div>
          <div>{{ [user.activeSub?.price, user.activeSub?.currency].join(' ') }}</div>
          <div>{{ user.activeSub?.offer?.kind }}</div>
        </template>
      </div>
      
      <uiButton
        v-if="users.length >= 30 && showMoreBtn"
        color="grey"
        class="mx-auto mt-4 w-40"
        :loading="loading"
        @click="loadUsers({ getMore: true, onlySubs: tab === 'subs' })"
      >
        Загрузить ещё
      </uiButton>
    </div>
  </div>
</template>

<script>
import UserSearch from '@/components/UserSearch'
import { API } from '@/config'
import { format, addDays } from 'date-fns'
import { getFullname } from '@/utils/name'

export default {
  name: 'UsersPage',
  components: {
    UserSearch
  },
  data () {
    return {
      loading: false,
      users: [],
      showMoreBtn: true,
      tab: 'all' // 'all' | 'subs'
    }
  },
  mounted () {
    this.loadUsers()
  },
  watch: {
    async tab(val) {
      this.showMoreBtn = true
      this.users = []

      if (val === 'all') await this.loadUsers()
      if (val === 'subs') await this.loadUsers({ onlySubs: true })
    }
  },
  methods: {
    openChat (chatId) {
      this.$router.push('/chats/' + chatId)
    },
    onCreate () {
      this.$router.push('/users/new')
    },
    format (date) {
      if (!date) return ''
      return format(new Date(date), 'dd.MM.yyyy в HH:mm')
    },
    async loadUsers ({ getMore, onlySubs } = { getMore: false, onlySubs: false }) {
      if (this.loading) return

      try {
        this.loading = true

        const { data } = await this.$http.post(API.USERS.latest, {
          after: getMore ? this.users.at(-1)._id : undefined,
          onlySubs
        })

        if (!data || data.err) {
          this.$notify(data.err)
          return
        }

        if (data.length < 30) {
          this.showMoreBtn = false
        }

        const users = data.map(user => {
          user.activeSub = user.subscriptions?.find(s => s.active) ?? null
          return user
        })

        this.users.push(...users)
      } catch (err) {
        this.$notify(err)
      } finally {
        this.loading = false
      }
    },
    getFullname,
    addDays
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
  width: 100%;
}

.user-search {
  margin-top: 50px;
}

.users {
  .user {
    width: 100%;
    display: flex;
    padding: 5px 0;
    cursor: pointer;
    font-size: 14px;
    color: #000;

    &:hover {
      color: @accent;
    }
  }

  .user.red {
    color: red;
  }
}
</style>
